<template>
    <center-layout>
        <cds-header
            title="New Entry"
            :subtitle="pp_date"
            subtitleOnClickHandler="subtitleClick"
            @subtitleClick="datePickerDialog = true"
        >
            <template v-slot:icons>
                <v-btn
                    icon
                    color="primary"
                    title="Save entry"
                    aria-label="Save entry"
                    @click="uploadFile"
                    :disabled="!content || !title"
                >
                    <v-icon v-text="mdiContentSaveOutline" />
                </v-btn>

                <v-btn
                    icon
                    color="primary"
                    title="Close new entry page"
                    aria-label="Close new entry page"
                    to="/entries"
                >
                    <v-icon v-text="mdiClose" />
                </v-btn>
            </template>
        </cds-header>

        <v-dialog
            ref="dialog"
            v-model="datePickerDialog"
            :return-value.sync="datePicker"
            persistent
            width="290px"
        >
            <v-date-picker v-model="datePicker" :max="dateToday" scrollable>
                <v-spacer />

                <v-btn
                    text
                    color="primary"
                    title="Close date picker"
                    aria-label="Close date picker"
                    @click="datePickerDialog = false"
                >
                    Cancel
                </v-btn>

                <v-btn
                    text
                    color="primary"
                    title="Save date picker date"
                    aria-label="Save date picker date"
                    @click="$refs.dialog.save(datePicker)"
                >
                    Save
                </v-btn>
            </v-date-picker>
        </v-dialog>

        <v-text-field
            v-model="title"
            type="text"
            label="Entry Title"
            outlined
        />

        <v-textarea
            outlined
            label="Entry Content (Markdown)"
            v-model="content"
        />

        <vue-markdown
            :source="content"
            :emoji="false"
            :linkify="false"
            class="notetap--quote"
        />
    </center-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { humanReadableDate, isoDate } from "@/helperFunctions.ts";
import { db, storage, storageBase } from "@/firebase";
import { mdiContentSaveOutline, mdiClose } from "@mdi/js";
import CenterLayout from "@/components/CenterLayout.vue";
import CdsHeader from "@/components/cds/CdsHeader.vue";
import VueMarkdown from "@adapttive/vue-markdown";

export default {
    name: "NewEntry",
    components: {
        VueMarkdown,
        CenterLayout,
        CdsHeader,
    },
    data: function () {
        return {
            title: "",
            content: "",
            dateToday: humanReadableDate(new Date()),
            datePicker: isoDate(new Date()),
            datePickerDialog: false,
            mdiContentSaveOutline: mdiContentSaveOutline,
            mdiClose: mdiClose,
        };
    },
    computed: {
        ...mapGetters({
            user: "user",
        }),
        pp_date: function () {
            return humanReadableDate(new Date(this.datePicker + " 00:00:00"));
        },
    },
    methods: {
        generateUUID: function () {
            let dt = new Date().getTime();
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function (c) {
                    var r = (dt + Math.random() * 16) % 16 | 0;
                    dt = Math.floor(dt / 16);
                    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
                }
            );
        },
        uploadFile: function () {
            let filename = this.generateUUID();

            let file = new Blob([this.content], { type: "text/plain" }),
                timestamp = new Date().toLocaleString();

            db.ref().child(this.user.data.uid).child(filename).set({
                title: this.title,
                filename: filename,
                date: this.datePicker,
                last_updated: timestamp,
            });

            let uploadTask = storage
                .ref()
                .child(this.user.data.uid)
                .child(filename + ".md")
                .put(file);

            uploadTask.on(
                storageBase.TaskEvent.STATE_CHANGED,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                () => {},
                (error) => console.error(error),
                () =>
                    this.$router.push({
                        name: "View",
                        params: { filename: filename },
                    })
            );
        },
    },
};
</script>

<style scoped>
.notetap--quote {
    border-left: 5px solid lightgray;
    padding-left: 15px;
}
</style>
